import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { UseeActivityStatus } from '../shared/models/useractivitystatus';
import { LocalStorageService } from './localStorageService';

export interface JwtPayload {
  sub: string;
  exp: number;
  roles?: string[];
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private tokenKey = 'token';
  public userDetails: UseeActivityStatus | null = null;

  constructor(private localStorage: LocalStorageService) {}

  setToken(token: string) {
    this.localStorage.set(this.tokenKey, token);
    this.decodeToken(token);
  }

  decodeToken(token: string) {
    try {
      this.userDetails = jwt_decode<UseeActivityStatus>(token);
      console.log("Decoded JWT:", this.userDetails);
    } catch (error) {
      console.error("Invalid JWT Token", error);
      this.userDetails = null;
    }
  }

  getToken(): string | null {
    return this.localStorage.get(this.tokenKey);
  }

  getUserDetails(): UseeActivityStatus | null {
    return this.userDetails;
  }

  getUserType(): string | null {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.userType;
    } catch {
      return null;
    }
  }

  clearToken() {
    this.localStorage.remove(this.tokenKey);
    this.userDetails = null;
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    return !!token && token !== 'null';
  }
}
